import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCurrentUser } from '../../actions/action_auth';
import { addStudent } from '../../actions/action_parent';
import { getGalleries } from '../../actions/action_gallery';

// React.js components
import BnlParentAddStudentForm from './bnl/BnlParentAddStudentForm';

class ParentAddStudentForm extends Component {
  constructor(props) {
    super(props);
  }

  renderForm() {
    // Always use BnlParentAddStudentForm which now properly handles guardian relationships
    // for companies that need them (GPI, Strawbridge, etc.) via the API endpoint
    return <BnlParentAddStudentForm history={this.props.history} />;
  }

  componentWillReceiveProps(nextProps) {
    // redirect to signup step 2 when directly accessing "//add-student"
    // if current user is truthy but hasn't completed signup
    if (nextProps.auth.currentUserId && !nextProps.auth.signupCompleted) {
      this.props.history.replace('/signup/step-2');
    }
  }

  render() {
    if (!this.props.auth.currentUserId || !this.props.auth.signupCompleted) {
      return <div id="loading" />;
    }

    return <div className="add-student">{this.renderForm()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    bnlPreShoot: state.bnlPreShoot,
    company: state.company,
    parent: state.parent,
    shoot: state.shoot,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setCurrentUser,
      addStudent,
      getGalleries,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParentAddStudentForm);
